import { Col, Row } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
}

const ApplicationDetails = ({ licence }: LicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <EpaField label={"Applicant"} value={licence.organisationname} />
          <EpaField label={"Application Status"} value={licence.lastatus} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Application Details"} content={bodyElements} />;
};

export default ApplicationDetails;
